import DashboardController, { DashboardConfigColumns, DashboardOptions } from '@js/controllers/DashboardController';

import M_AddEditCategories from '../modals/AddEditCategories';
class CategoriesTab extends DashboardController {
	constructor(el: HTMLElement) {
		super(el, 'Catégorie', 'PRODUCTS._CATEGORIES', 'categories');
	}

	protected buttonAdd() {
		new M_AddEditCategories().open().then(() => {
			this.getData();
		});
	}

	//TODO: Ajouter un mode de visu sur la modal
	protected buttonView(id: string) {
		new M_AddEditCategories(id).open().then(() => {
			this.getData();
		});
	}

	protected buttonEdit(id: string) {
		new M_AddEditCategories(id).open().then(() => {
			this.getData();
		});
	}

	protected getTitleContextMenu(data: { [key: string]: any }): string {
		return data.label.formattedValue;
	}

	protected getDisabledActionButtons(data: { [key: string]: any }): {
		edit?: boolean, view?: boolean, duplicate?: boolean, delete?: boolean, print?: boolean
	} {
		return {
			edit: false,
			view: false,
			duplicate: false,
			delete: data.numberUse.value !== 0,
			print: false
		};
	}

	protected get optionsColumnsGrid(): DashboardOptions {
		return {
			columns: {
				displayed: {
					icons: false,
					selection: false
				}
			},
			actionButtons: {
				displayed: {
					add: true,
					edit: true,
					view: false,
					duplicate: false,
					delete: true,
					print: false
				}
			}
		};
	}

	protected get configColumns(): DashboardConfigColumns {
		return [
			{
				key: '_id',
				type: 'primaryKey',
				name: 'ID'
			},
			{
				key: 'label',
				type: 'string',
				name: 'Nom'
			},
			{
				key: 'numberUse',
				type: 'number',
				name: 'Nombre de produits'
			}
		];
	}
}

export default CategoriesTab;
